import { render, staticRenderFns } from "./line-animate.vue?vue&type=template&id=4a3af991&scoped=true"
var script = {}
import style0 from "./line-animate.vue?vue&type=style&index=0&id=4a3af991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3af991",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/carousel/line-animate.vue
// module id = null
// module chunks = 